<template>
  <div>
    <div class="category">
      <CategoryCard v-for="cat in categories" :item="cat" />
    </div>
  </div>
</template>
<script>
import CategoryCard from "@/parts/Front/nicecomponents/subcomponents/CategoryCard";

export default {
  name: 'HomeCategories',
  components: {CategoryCard},
  computed: {
    categories() {
      return [
        {
          title: 'کیف',
          image: {
            url: require('@/assets/images/2.png')
          },
          to: '/products/category/45/کیف'
        },
        {
          title: 'زنانه',
          image: {
            url: require('@/assets/images/3.png')
          },
          to: '/products/category/2/زنانه'
        },
        {
          title: 'اکسسوری',
          image: {
            url: require('@/assets/images/banner3.png')
          },
          to: '/products/category/4/اکسسوری?category_id=4'
        },

      ]
    }
  }
}
</script>
<style scoped>
.category {
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
}

</style>
